.chevron-arrow {
  --color: currentcolor;
  --size: 32px;

  stroke: var(--color);
  display: inline-block;
  height: 100%;
  max-height: var(--size);
  max-width: var(--size);
  stroke-width: 2px;
  stroke-linecap: round;
  transform: rotate(var(--rotation));
  width: 100%;
}

.s {
  --size: 24px;
}

.l {
  --size: 48px;
}

.xl {
  --size: 64px;
}

ui-sprite-svg {
  --rotation: 0deg;
}

.down {
  --rotation: 90deg;
}

.left {
  --rotation: 180deg;
}

.up {
  --rotation: 270deg;
}
